module.exports = __webpack_public_path__ + "assets/img/block-7dc1929a.png";